export function RYPLogoThumbnail({
  size = 22,
  color = '#1a1c1e',
}: {
  size?: number;
  color?: string;
}) {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <rect width="100%" height="100%" fill="#FFFFFF" />

      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none"
      >
        <path
          d="M0 2560 l0 -2560 2560 0 2560 0 0 2560 0 2560 -2560 0 -2560 0 0
-2560z m1483 1487 c186 -54 300 -171 343 -353 12 -54 14 -134 12 -457 -3 -382
-4 -394 -26 -448 -30 -74 -88 -139 -155 -174 l-54 -29 56 -36 c63 -41 102 -83
133 -144 46 -89 48 -115 48 -612 0 -464 7 -621 34 -723 l13 -51 -223 0 -223 0
-12 43 c-25 92 -29 180 -29 643 0 490 -5 568 -38 613 -40 55 -67 66 -168 69
l-94 4 -2 -684 -3 -683 -222 -3 -223 -2 0 1526 0 1526 388 -4 c320 -4 397 -8
445 -21z m993 -527 c59 -302 111 -547 115 -542 3 4 52 241 108 527 56 286 104
530 106 543 5 22 5 22 225 22 121 0 220 -2 220 -4 0 -2 -24 -100 -54 -218 -30
-117 -131 -518 -225 -890 l-171 -676 0 -631 0 -631 -220 0 -220 0 0 631 0 632
-220 876 c-122 482 -223 884 -226 894 -5 16 10 17 224 17 l229 0 109 -550z
m1763 527 c189 -56 307 -180 346 -366 21 -101 22 -813 1 -913 -44 -203 -183
-336 -391 -373 -44 -8 -140 -14 -212 -15 l-133 0 0 -680 0 -680 -220 0 -220 0
0 1526 0 1526 388 -5 c314 -3 397 -7 441 -20z"
        />
        <path
          d="M1100 3226 l0 -456 88 0 c111 0 160 20 188 76 18 36 19 64 19 379 0
322 -1 342 -20 374 -37 62 -64 75 -175 79 l-100 4 0 -456z"
        />
        <path
          d="M3858 3674 c-5 -4 -8 -209 -8 -457 l0 -449 104 4 c117 3 143 15 181
79 19 32 20 52 20 374 0 322 -1 342 -20 374 -37 62 -64 75 -173 79 -53 2 -100
1 -104 -4z"
        />
      </g>
    </svg>
  );
}
